module.exports = __webpack_public_path__ + "static/media/futworklogo.6ba625ab.png";